import isNil from 'lodash/isNil';
import { all, call, select, takeEvery } from 'redux-saga/effects';

import {
  checkFacebookConnectStatus as checkFacebookConnectStatusAction,
  setFacebookTokenValidity,
  updateFacebookTokenValidity,
} from '../actions/Social';
import { SocialActions } from '../constants/Social';
import { getFacebookShareAppId } from '../lib/configuration/TunerVarUtils';
import { getCurrentListenerIdFromState } from '../lib/ListenerUtils';
import {
  checkFacebookConnectStatus,
  loadFacebookSDK,
  updateFbTokenValidity,
} from '../lib/Social/FacebookService';

function* updateFacebookTokenValidityWorker() {
  const listenerId = yield select(getCurrentListenerIdFromState);
  yield call(updateFbTokenValidity, setFacebookTokenValidity.bind(null, listenerId));
}

function* loadFbSdkAndUpdateTokenValidity() {
  if (isNil(window.FB)) {
    const fbAppId = yield select(getFacebookShareAppId);
    if (fbAppId) {
      yield call(loadFacebookSDK, fbAppId, updateFacebookTokenValidity);
    }
  } else {
    yield call(updateFacebookTokenValidityWorker);
  }
}

function* checkFacebookConnectStatusWorker() {
  yield call(checkFacebookConnectStatus);
}

function* loadFbSdkAndUpdateLoginStatus() {
  if (isNil(window.FB)) {
    const fbAppId = yield select(getFacebookShareAppId);
    if (fbAppId) {
      yield call(loadFacebookSDK, fbAppId, checkFacebookConnectStatusAction);
    }
  } else {
    yield call(checkFacebookConnectStatusWorker);
  }
}

export default function* socialSaga() {
  yield all([
    takeEvery(SocialActions.LOAD_FB_SDK_AND_UPDATE_TOKEN_VALIDITY, loadFbSdkAndUpdateTokenValidity),
    takeEvery(SocialActions.UPDATE_FACEBOOK_TOKEN_VALIDITY, updateFacebookTokenValidityWorker),
    takeEvery(SocialActions.CHECK_FACEBOOK_CONNECT_STATUS, checkFacebookConnectStatusWorker),
    takeEvery(SocialActions.LOAD_FB_SDK_AND_UPDATE_LOGIN_STATUS, loadFbSdkAndUpdateLoginStatus),
  ]);
}
